import AddClassroom from 'components/AddClassroom';
import Auth from 'components/Auth';
import Register from 'components/Register';
import { CareerRoadmap, ClassesOverview, ClassOverview, Entry, NoMatch } from 'pages';
import { Conventions, Events, Finder, Presentations } from 'pages/Ads';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';

const PrivateRoute = ({ component: Component, user, sessionStatus, ...rest }) => {
  if (sessionStatus === undefined) {
    return <></>;
  }

  return (
    <Route
      {...rest}
      render={props =>
        user ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/auth/login',
              state: { from: props.location, user },
            }}
          />
        )
      }
    />
  );
};

const handleAppcues = props => {
  const { user, isLoaded, isSignedIn } = props;
  if (!isLoaded || !isSignedIn) {
    return;
  }

  if (window.Appcues !== undefined && process.env.NODE_ENV !== 'development') {
    window.Appcues.page();

    if (user) {
      const { firstName, lastName, primaryEmailAddress } = user;
      const uuid = localStorage.getItem('user_uuid');

      window.Appcues.identify(uuid, {
        firstName,
        lastName,
        primaryEmailAddress,
      });
    } else {
      window.Appcues.reset();
    }
  }
};

const Routes = () => {
  const { t } = useTranslation();
  const { user, isSignedIn, isLoaded } = useUser();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    handleAppcues({
      user,
      isLoaded,
      isSignedIn,
    });
  }, [pathname, user, isLoaded, isSignedIn]);

  return (
    <Switch>
      <Route path="/" exact component={Entry} />
      <Route path={`/${t('roadmap')}`} component={CareerRoadmap} />
      <PrivateRoute
        path={`/${t('classes')}`}
        user={user}
        sessionStatus={isSignedIn}
        component={ClassesOverview}
      />
      <PrivateRoute
        path={`/${t('class')}/:id`}
        user={user}
        sessionStatus={isSignedIn}
        component={ClassOverview}
      />
      <Route path="/auth/login" component={Auth} />
      <Route path="/auth/register" component={Register} />
      <Route path="/auth/add_classroom" component={AddClassroom} />
      <Route path={`/${t('presentations')}`} component={Presentations} />
      <Route path={`/${t('conventions')}`} component={Conventions} />
      <Route path={`/${t('finder')}`} component={Finder} />
      <Route path={`/${t('events')}`} component={Events} />
      <Route component={NoMatch} />
    </Switch>
  );
};

export default Routes;
